import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
//import { AuthGuard } from './_shared/guards/auth.guard';
import { AuthGuard } from './_shared/guards/auth.guard';
import { BasicLayoutComponent } from './layout/basic-layout/basic-layout.component';
import { CampaignGuard } from './_shared/guards/campaign.guard';
import { SocialPostsComponent } from './social-posts/social-posts.component';
import { SessionExpiredComponent } from './session-expired/session-expired.component';
import { NewerSessionComponent } from './newer-session/newer-session.component';
import { ApprovalRedirectComponent } from './approval-redirect/approval-redirect.component';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.module').then((m) => m.AuthModule)
  },
  {
    path: 'manage-content',
    component: BasicLayoutComponent,
    data: {
      breadcrumb: 'Manage Content',
      breadcrumb_group : true
    },
    children: [
      {
        path: 'articles',
        loadChildren: () => import('./manage-content/articles/article.module').then(m => m.ArticleModule),
        data: {
          breadcrumb: 'Articles'
        }
      },
      { path: '**', redirectTo: 'articles',  pathMatch: 'full' }
    ],
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard]
  },
  //{ path: 'settings',
  //  component: BasicLayoutComponent,
  //  data: {
  //    breadcrumb: 'Settings'
  //  },
  //  loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule),
  //  canActivate: [AuthGuard]
  //},
  { path: 'templates',
    component: BasicLayoutComponent,
    data: {
      breadcrumb: 'Templates'
    },
    loadChildren: () => import('./templates/templates.module').then(m => m.TemplatesModule),
    canActivate: [AuthGuard]
  },
  { 
    path: 'topic-ideas', 
    component: BasicLayoutComponent,
    loadChildren: () => import('./topic-ideas/topic-ideas.module').then(m => m.TopicIdeasModule),
    canActivate: [AuthGuard]
  },
  { 
    path: 'dashboard', 
    component: BasicLayoutComponent,
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
   canActivate: [AuthGuard]
  },
  { 
    path: 'brand-voice', 
    component: BasicLayoutComponent,
    loadChildren: () => import('./profile-brand-voice/profile-brand-voice.module').then(m => m.ProfileBrandVoiceModule),
   canActivate: [AuthGuard]
  },
  { 
    path: 'target-audience', 
    component: BasicLayoutComponent,
    loadChildren: () => import('./profile-target-audience/profile-target-audience.module').then(m => m.ProfileTargetAudienceModule),
   canActivate: [AuthGuard]
  },
  //{ 
  //  path: 'settings', 
  //  component: BasicLayoutComponent,
  //  loadChildren: () => import('./content-settings/content-settings.module').then(m => m.ContentSettingsModule),
  // canActivate: [AuthGuard]
  //},
  {
    path: 'whats-new',
    component: BasicLayoutComponent,
    loadChildren: () => import('./whats-new/whats-new.module').then(m => m.WhatsNewModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'campaigns',
    component: BasicLayoutComponent,
    loadChildren: () => import('./campaigns/campaigns.module').then(m => m.CampaignsModule),
    canActivate: [AuthGuard,CampaignGuard]
  },
  { 
    path: 'event-calender', 
    component: BasicLayoutComponent,
    loadChildren: () => import('./event-calender/event-calender.module').then(m => m.EventCalenderModule),
    canActivate: [AuthGuard,CampaignGuard]
  },
  {
    path: 'social-posts', 
    component: BasicLayoutComponent,
    loadChildren: () => import('./social-posts/social-posts.module').then(m => m.SocialPostsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'settings',
    component: BasicLayoutComponent,
    loadChildren: () => import('./new-settings/new-settings.module').then(m => m.NewSettingsModule),
    canActivate: [AuthGuard]
  },
  //{
  //  path: 'knowledge',
  //  component: BasicLayoutComponent,
  //  loadChildren: () => import('./knowledge-vault/knowledge-vault.module').then(m => m.KnowledgeVaultModule),
  //  canActivate: [AuthGuard]
  //},
  { path: 'session-expired', component: SessionExpiredComponent },
  { path: 'newer-session', component: NewerSessionComponent },
  // Unguarded on purpose: AuthGuard sends moderators here, so guarding it would loop.
  { path: 'approval-redirect', component: ApprovalRedirectComponent },
  { path: '**', redirectTo: 'dashboard', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
